import * as React from "react";
import { Button, Switch } from "antd";
import { Modal } from "Components/General/Modal/GenericModal";
import { UploadedTmpFile } from "./FileUploadStore";
import { observer } from "mobx-react";
import { replaceFileStore } from "./ReplaceFileStore";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { TableWithRadios, TableWithRadiosColumnProps } from "Components/ScrollableTable/TableWithRadios";
import { FormatData } from "utils/FormatData";
import { FileTypeIcon } from "../Components/FileTypeIcon";
import { dayjs } from "Config/dayjs";
import { ButtonsRow } from "Components/Form/ButtonsRow";

interface ReplaceFilePickerProps extends WithTranslation {
  onEdit: (value: UploadedTmpFile) => void;
}

interface ReplaceFilePickerState {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedFile: any;
  fileTypeFilter: boolean;
}

export const ReplaceFilePicker = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<ReplaceFilePickerProps, ReplaceFilePickerState> {
      constructor(props: ReplaceFilePickerProps) {
        super(props);
        this.state = { selectedFile: undefined, fileTypeFilter: true };
      }

      confirmPickedFile = () => {
        if (this.state.selectedFile) {
          this.props.onEdit({
            ...replaceFileStore.file,
            oldFile: this.state.selectedFile,
            errors: { ...replaceFileStore.file.errors, existingFile: this.state.selectedFile },
          });
        }
        replaceFileStore.hideModal();
      };

      handleSelectRow = (file: API_FileDataEntity) => {
        this.setState({ selectedFile: file });
      };

      toggleFileTypeFilter = () => {
        this.setState({ fileTypeFilter: !this.state.fileTypeFilter });
      };

      renderTitle = () => {
        const { t } = this.props;
        const { fileTypeFilter } = this.state;
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div className="ant-modal-title">{this.props.t("Replace file")}</div>
            <div style={{ fontSize: "1rem" }}>
              <Switch className="mr-5" onChange={this.toggleFileTypeFilter} checked={fileTypeFilter} />
              {t("Show only same filetype")}
            </div>
          </div>
        );
      };

      get filteredFiles() {
        const { fileTypeFilter } = this.state;
        if (fileTypeFilter) {
          const fileType = replaceFileStore.file?.type;
          return replaceFileStore.data.filter((item) => item.type === fileType);
        } else {
          return replaceFileStore.data.slice();
        }
      }

      render() {
        const { t } = this.props;
        const displayedFiles = this.filteredFiles;
        const columns: TableWithRadiosColumnProps<API_FileDataEntity>[] = [
          {
            dataKey: "type",
            width: 40,
            cellRenderer: ({ rowData }: { rowData: API_FileDataEntity }) => (
              <FileTypeIcon malware={rowData.malware} type={rowData.type} state={rowData.state} />
            ),
            disableSort: true,
          },
          {
            dataKey: "name",
            label: t("Filename"),
            width: 200,
            flexGrow: 1,
            disableSort: true,
          },
          {
            dataKey: "size",
            label: t("Size"),
            width: 110,
            cellRenderer: ({ cellData }) => (cellData ? FormatData.formatBytes(cellData, 1) : null),
            disableSort: true,
          },
          {
            dataKey: "created",
            label: t("Last modified"),
            width: 180,
            cellRenderer: ({ cellData }) => dayjs(+cellData).format("lll"),
            disableSort: true,
          },
        ];
        return (
          <Modal
            title={this.renderTitle()}
            open={replaceFileStore.isVisible}
            onCancel={replaceFileStore.hideModal}
            destroyOnHidden={true}
            width="100%"
            className="full-height-modal"
            style={{ maxWidth: 1200 }}
            footer={null}
          >
            <div className="scrollable-table-wrapper">
              <TableWithRadios<API_FileDataEntity>
                rowKey="id"
                columns={columns}
                rowCount={displayedFiles.length}
                defaultSelectedRowKey={replaceFileStore.existingFileId}
                data={displayedFiles}
                loading={replaceFileStore.state === "LOADING"}
                onSelectRow={this.handleSelectRow}
              />
              <ButtonsRow justify="space-between">
                <Button onClick={replaceFileStore.hideModal}>{t("Cancel")}</Button>
                <Button onClick={this.confirmPickedFile} type="primary">
                  {t("Select")}
                </Button>
              </ButtonsRow>
            </div>
          </Modal>
        );
      }
    }
  )
);
